// @flow

import React, { type Node, useMemo } from 'react';
import { getGatewayVoucherUrl, usePendingIncomingPayment, redirectIfCheckForConfirmationIsEnabled } from '@tectonics/prs/incoming-payment';
import { Button } from '../../../atoms';

export function SavePdfButton(): Node {
  const incomingPayment = usePendingIncomingPayment();

  const gatewayVoucherUrl = getGatewayVoucherUrl(incomingPayment);

  const href = useMemo(() => {
    const url = new URL(gatewayVoucherUrl);
    url.searchParams.append('format', 'pdf');
    return url.toString();
  }, [gatewayVoucherUrl]);

  return (
    <Button
      as="a"
      block
      flat
      href={href}
      outline
      rel="noopener noreferrer"
      size="lg"
      target="_blank"
      type="primary"
      data-test-id="efecty-pdf-button"
      onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment) }
    >
      Guardar Recibo Efecty en PDF
    </Button>
  );
}
